export default __webpack_public_path__ + "static/media/TomDadColin_05.ac775b74.png";